/**
 * Data no formato brasileiro (dd/mm/aaaa), independente do idioma do navegador.
 * `value`/`onChange` trabalham em ISO (aaaa-mm-dd), que é o que a API espera.
 */
import React, { useEffect, useState } from 'react';

const isoParaBR = (iso) => (iso && /^\d{4}-\d{2}-\d{2}$/.test(iso) ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}` : '');

function brParaISO(br) {
  const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(br || '');
  if (!m) return '';
  const [, d, mes, a] = m;
  const dt = new Date(Number(a), Number(mes) - 1, Number(d));
  if (dt.getFullYear() !== Number(a) || dt.getMonth() !== Number(mes) - 1 || dt.getDate() !== Number(d)) return '';
  return `${a}-${mes}-${d}`;
}

export default function DataBR({ value, onChange, className = 'form-control', ...rest }) {
  const [texto, setTexto] = useState(isoParaBR(value));
  useEffect(() => { setTexto(isoParaBR(value)); }, [value]);
  const mudar = (e) => {
    const dig = e.target.value.replace(/\D/g, '').slice(0, 8);
    const fmt = dig.length > 4 ? `${dig.slice(0, 2)}/${dig.slice(2, 4)}/${dig.slice(4)}` : dig.length > 2 ? `${dig.slice(0, 2)}/${dig.slice(2)}` : dig;
    setTexto(fmt);
    const iso = brParaISO(fmt);
    if (iso || !fmt) onChange(iso);
  };
  const invalido = texto.length === 10 && !brParaISO(texto);
  return (
    <input {...rest} className={className} inputMode="numeric" placeholder="dd/mm/aaaa" value={texto} onChange={mudar}
      style={{ ...(rest.style || {}), borderColor: invalido ? '#c0392b' : undefined }} title={invalido ? 'Data inválida' : undefined} />
  );
}
